<template>
    <div>
        <el-page-header @back="goBack" content="用户行为对比分析"></el-page-header>
        <el-card style="margin-top: 20px; font-size: 17px"  shadow="never">
            <div >
                <i class="el-icon-search"></i>
                <span>筛选搜索</span>
                <el-button
                        size="small"
                        style="position: relative; left: 1180px;"
                        type="primary"
                        @click="exportExcel">
                    导出
                </el-button>
                <el-button
                        size="small"
                        style="position: relative; left: 1200px;"
                        type="primary"
                        @click="query">
                    查询结果
                </el-button>
            </div>
            <div style="margin-top: 10px">
                <el-form :inline="true" :model="queryData" size="small" label-width="90px">
                    <el-form-item label="日期：">
                        <el-date-picker
                                v-model="queryData.timeDate"
                                type="daterange"
:clearable="false"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="任务类型：">
                        <el-select v-model="queryData.type" >
                        <el-option v-for="item in behavior" :label="item.name" :key="item.id" :value="item.id" >
                        </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="新老用户：">
                    <el-select v-model="queryData.user" clearable placeholder="请选择">
                        <el-option v-for="item in users" :label="item.name" :key="item.id" :value="item.id"></el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="渠道：">
                        <el-select v-model="queryData.channelId"  @change="selectGoodsByChannelId($event)" clearable placeholder="请选择">
                            <el-option value="0" label="全部"></el-option>
                            <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
                        </el-select>
                        <el-select v-model="queryData.subChannelId"   clearable placeholder="请选择" >
                            <el-option value="0" label="全部"></el-option>
                            <el-option v-for="item in subChannelList" :label="item.name" :key="item.id" :value="item.subChannel"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card style="margin-top: 0;font-size: 17px" shadow="never">
            <i class="el-icon-tickets"></i>
            <span>数据列表</span>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="list"
                      style="width: 100%"
                      :header-cell-style="{background:'#282828'}"
                      border>
                <el-table-column label="时间日期" align="center">
                    <template slot-scope="scope">{{scope.row.dt}}</template>
                </el-table-column>
                <el-table-column label="1的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.total1}}</template>
                </el-table-column>
                <el-table-column label="2的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.total2}}</template>
                </el-table-column>
                <el-table-column label="3的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.total3}}</template>
                </el-table-column>
                <el-table-column label="4的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.total4}}</template>
                </el-table-column>
                <el-table-column label="5的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.total5}}</template>
                </el-table-column>
                <el-table-column label="6的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.total6}}</template>
                </el-table-column>
                <el-table-column label="7的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.total7}}</template>
                </el-table-column>
                <el-table-column label="8的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.total8}}</template>
                </el-table-column>
                <el-table-column label="9的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.total9}}</template>
                </el-table-column>
                <el-table-column label="10的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.total10}}</template>
                </el-table-column>
                <el-table-column label="大于10的用户数" align="center">
                    <template slot-scope="scope">{{scope.row.totalMore10}}</template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[20,30,50]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next"
                        :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import {
        downloadData,
        searchUserBehaviorReport,
        channelList
    } from "@/http/api";
    import utils from '@/utils';
    export default {
        name: "UserBehaviorReport",

        data(){
            return{
                list: [],
                queryInfo: {
                    pagesize: 20,
                    pagenum: 1,
                    total: 0,
                },
                queryData: {
                    user: 0,
                    channelId:'',
                    subChannelId:'',
                    type:0,
                    timeDate: ['', ''],
                },
                queryTrueData: {
                    channelId:'',
                    subChannelId:'',
                    type:0,
                    startTime: '',
                    endTime: '',
                    order: null,
                    prop: null,
                },
                channelList:[],
                subChannelList:[],
                users: [{id: 0, name: '全部'},
                    {id: 1, name: '新用户'},
                    {id: 2, name: '老用户'}],
                behavior: [{id: 0, name: '广告视频数/个'},
                    {id: 1, name: '游戏时长/分钟'}],
            }
        },
        methods:{
            goBack() {
                this.$router.push({ path: '/dataReport'});
            },
            queryUserBehaviorReport(){
                this.queryTrueData.startTime= this.queryData.timeDate[0];
                this.queryTrueData.endTime=this.queryData.timeDate[1];
                this.queryTrueData.type = this.queryData.type;
                this.queryTrueData.channelId=this.queryData.channelId;
                this.queryTrueData.subChannelId=this.queryData.subChannelId;
                this.queryTrueData.user=this.queryData.user;
                this.queryTrueData.size=this.queryInfo.pagesize;
                this.queryTrueData.page=this.queryInfo.pagenum;
                searchUserBehaviorReport(this.queryTrueData).then(resp=>{
                    this.list=resp.data.info.content;
                    this.queryInfo.total= resp.data.info.totalElements;
                });
            },
            selectGoodsByChannelId(val){
                this.watchTag = val;
                if(val !== null && val !== '' && val !== undefined && val !=='0') {
                    this.subChannelList = this.channelList.filter(channel => channel.id === val )[0].children.filter(subChannel=>subChannel.state===1);
                }
                if (val==='0'){
                    this.subChannelList=[];
                }
            },
            handleSizeChange(newSize){
                this.queryInfo.pagesize=newSize;
                this.queryUserBehaviorReport();

            },
            query(){
                this.queryInfo.pagenum=1;
                this.queryUserBehaviorReport();
            },
            exportExcel() {
                let fileName = new Date().toLocaleString() + '用户行为对比分析.xlsx';
                downloadData(
                    '/data/user/searchBehaviorExcel',
                    Object.assign(this.queryTrueData),
                    fileName
                )
            },

            handleCurrentChange(newPage){
                this.queryInfo.pagenum=newPage;
                this.queryUserBehaviorReport();
            },
        },
        created() {
            this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
            channelList().then(resp=>{
                this.channelList=resp.data.info;
            });
            this.queryUserBehaviorReport();
        }
    }
</script>

<style scoped>
</style>